import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import {
  renderResponsable,
  roles,
  statusPrestationsValues,
} from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import {
  setPropertiesPrestation,
  updateAdminPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { AddresseItem } from "../../container/Addresses/AddresseItem/AddresseItem";
import {
  isCheckedAddress,
  renderAdress,
  typeAddress,
} from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { inputsAddresseItem } from "../../container/Addresses/AddresseItem/AddresseItemInputs";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";
import { addresseItemMapsInputs } from "../../container/Addresses/AddresseItem/AddresseItemMapsInputs";
import { UserOutlined } from "@ant-design/icons";
import routes from "../../../engine/routes";

export const SelectResponsable = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const formRefAddress = useRef(null);

  const context = useContext(ModalContext);
  const { params } = context;
  const { institution, formRef } = params;
  const dispatch = useDispatch();

  const close = params => {
    setOpen(false);
    context.closeModal(modalsByContext.SelectResponsable, params);
  };
  const onSubmitForm = async data => {

    let responsable = formRefAddress.current._responsable.find(
      e => e._id === data.responsable,
    );


    close({ _id: data.responsable, data: responsable });
  };

  const config = {
    key: institution + modalsByContext.SelectResponsable,
    containerStyle: { minWidth: "500px" },
    title: "Sélectionner un responsable",
    open: open,
    width: 1000,
    onOk: () => {
      formRefAddress.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          refForm={formRefAddress}
          dataSource={[
            {
              parentLabel: "",
              children: [
                {
                  name: "responsable",
                  label: "Liste des responsables prédéfinis",
                  type: "dynamic-select",
                  multiple: false,
                  endPoint: () => `responsables?institution=${institution}`,
                  // updateEndPoint: [change],
                  itemsCallBack: responsables => {
                    if (responsables.length > 0) {
                      formRefAddress.current.setFieldsValue({
                        responsable: responsables[0]._id,
                      });
                    }
                  },
                  inputSize: "small",
                  quoteIcon: "edit",
                  watchValuesCallback: (value, form, r) => {},
                  addonBefore: <UserOutlined />,
                  quote: (
                    <>
                      <p>
                        Vous pouvez les éditer sur la page de l'institution{" "}
                      </p>
                      <a
                        target={"_blank"}
                        href={
                          routes.institutions(institution).responsables.path
                        }
                      >
                        Editer les responsables d'entretien
                      </a>
                    </>
                  ),
                  noSorting: true,
                  itemCallback: resp => {
                    return {
                      key: resp._id,
                      label: renderResponsable(resp),
                      value: resp._id,
                    };
                  },
                  col: 24,
                },
              ],
            },
          ]}
          labelCol={24}
          handleSubmit={onSubmitForm}
          wrapperCol={24}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        // loading={loadingEdit}
        // disabled={loadingEdit}
        onClick={async () => {
          try {
            formRefAddress.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        Sélectionner le responsable
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};
